module.exports = __webpack_public_path__ + "img/Sure Reach.d8a0c756.png";